module.exports = __webpack_public_path__ + "r-v3/img/repeat_white.56e394f9.svg";